import { BaseOptionModel } from '@/models'

export const enum Promo {
    ZERO_COMMISSION = 'zeroCommission',
}

export enum Flow {
    FIAT_TO_CRYPTO = 'fiat-to-crypto',
    CRYPTO_TO_FIAT = 'crypto-to-fiat',
    CRYPTO_TO_CRYPTO = 'crypto-to-crypto',
    FIAT_TO_FIAT = 'fiat-to-fiat',
}

export const enum WalletTypes {
    PAYBIS = 'paybisWallet',
    EXTERNAL = 'externalWallet',
}

export interface State {
    selected: BaseOptionModel;
    flow: Flow;
    amount: string;
    equivalentAmount: string;
    showDropDown: boolean;
    error: string | null;
}
